import React, { useCallback } from 'react';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import HomePage from '@/pages/HomePage';

const AuthenticatedApp: React.FC = () => {
  const history = useHistory();
  const handleAuthenticated = useCallback(
    (returnTo: string) => history.replace(returnTo),
    [history]
  );

  return (
    <AuthProvider onAuthenticated={handleAuthenticated}>
      <HomePage />
    </AuthProvider>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AuthenticatedApp />
  </BrowserRouter>
);

export default App;
